export const withdrawRequest = {
  commissionPercent: 10.0,
  processedDays: 3,
};
